import { api } from ".";

const basePath = "/department";

/**
 * Departman oluşturur.
 *
 * ⚠ `workHours` 2.35'te kaldırıldı — departman çalışma düzeni taşımıyor,
 * ölçüt vardiya atamasından geliyor. Backend'in validator'ı da alanı artık
 * tanımıyor.
 */
export const createDepartment = async ({ name, description }: any) => {
  try {
    const res = await api.post(`${basePath}`, {
      name,
      description,
    });
    return res;
  } catch (error) {
    return error;
  }
};

export const updateDepartmentById = async ({ id, updates }: any) => {
  try {
    const res = await api.put(`${basePath}`, {
      _id: id,
      ...updates,
    });
    return res;
  } catch (error) {
    console.error("Error updating user:", error);
    return error;
  }
};

export const getDepartmentsList = async (params: Record<string, any> = {}) => {
  try {
    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(([_, value]) => value !== undefined)
    );
    const res = await api.get(`${basePath}/list`, { params: filteredParams });
    return res;
  } catch (error) {
    return error;
  }
};

export const deleteDepartment = async ({ id }: { id: string }) => {
  try {
    const res = await api.delete(`${basePath}`, {
      data: { _id: id },
    });
    return res;
  } catch (error) {
    return error;
  }
};
export const getDepartmentSelectData = async () => {
  try {
    const res = await api.get(`${basePath}/select-data`);
    return res;
  } catch (error) {
    return error;
  }
};

export const getDepartmentById = async ({ id }: any) => {
  try {
    const res = await api.get(`${basePath}`, { params: { _id: id } });
    console.log("API response:", res); 
    return res;
  } catch (error) {
    return error;
  }
};